import { BsFillSendFill } from "react-icons/bs"; 
import { HiChevronDoubleRight } from "react-icons/hi"; 
import { SiMicrosoftexcel } from "react-icons/si"; 
import { BiLockOpenAlt } from "react-icons/bi"; 
import { BiLockAlt } from "react-icons/bi"; 
import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import * as FxLog from '../../fx/FxLog';
import * as FxDat from '../../fx/FxDat';
import * as FxStr from '../../fx/FxStr';
import * as FxBrowser from '../../fx/FxBrowser';
import GxList from '../../gx/GxList';
import GxPrint from '../../gx/GxPrint';
import CxDlgAlert from '../../cx/CxDlgAlert';
import { useWindowSize } from '../../hx/useWindowSize';
import * as FxTable from '../../fx/FxTable';
import * as FxFetch from '../../fx/FxFetch';
import CxSnackbar from '../../cx/CxSnackbar';
import { StoreMarketing, isApp,  } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxIconButton from '../../cx/CxIconButton';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import { useNav } from '../../hx/useNav';


const MxMarketingList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();
  const size = useWindowSize();

  const r_list = React.useRef(null);
  let r_print = React.useRef(null);

  const r_snack_success = React.useRef(null);
  const r_snack_error = React.useRef(null);
  const r_dlg_alert = React.useRef(null);

  // eslint-disable-next-line
  const [storeMarketing, setStoreMarketing] = useSessionStorage('StoreMarketing', StoreMarketing);

  const [lockExclude, setLockExclude] = React.useState(true);
  const [lockSend, setLockSend] = React.useState(true);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const doExcludeClient = (row) => {
    let inClient = row.inClient;
    storeMarketing.arExcludedId += "|" + inClient;
    Promise.all([setStoreMarketing(storeMarketing)]).then((result) => {
      Promise.all([r_list.current.setdeepAddParams(getAddParams())]).then((result) => {
        r_list.current.refresh();
      });
    });
  }

  const goNext = async () => {
    r_dlg_alert.current.setOpen(true);
    Promise.all([setListedId()]).then((result) => {
      r_dlg_alert.current.setOpen(false);
      if (storeMarketing.marketingType==='E') {
        navTo("marketing-option-e");
      }
      if (storeMarketing.marketingType==='S') {
        navTo("marketing-option-s");
      }
    });
  }

  const setListedId = () => {
    let record = {};
    record['pageNo'] = '0';
    record['pageSize'] = '1000';
    record['sortBy'] = '';
    record['filter'] = '';
    record['group'] = '';
    let addParams = getAddParams();
    if (addParams) {
      let params = addParams.split("&");
      params.forEach(function (item, index) {
        record[item.split("=")[0]] = item.split("=")[1];
      });
    }
    return Promise.all([FxFetch.doJsonX("marketing", record)]).then((result) => {
      let rs = result[0].reverse();
      let all = '';
      if (rs) {
        FxLog.infox('MxMarketingList.setListedId', '...rs:', rs);
        for (let i = 0; i < rs.length; i++) {
          let inClient = rs[i].inClient || '';
          let inAnimal = rs[i].animal_inAnimal || '';
          let inPs = rs[i].inPs || '';
          let dtNext = FxStr.substringBefore(rs[i].dtNext, ' ');
          all += inClient + "|" + inAnimal + "|" + inPs + "|" + dtNext + '\n';
        }
        FxLog.infox('MxMarketingList.setListedId', '...all:', '\n'+all);
        storeMarketing.arListedId = all;
        return Promise.all([setStoreMarketing(storeMarketing)]).then((result) => {
          return;
        });
      }
    });
  }

  const getWhatsappNumber = (txMobile) => {
    let record = {};
    record['txMobile'] = txMobile;
    return Promise.all([FxFetch.doJsonX('comms/get_whatsapp_number', record)]).then((result) => {
      if (result[0]) {
        return result[0].theValue;
      }
    });
  }

  const doSendWhatsapp = (row) => {
    let txContent = storeMarketing.txWhatsapp;

    // Reemplazo dinámico de marcadores usando expresiones regulares globales
    if (txContent) {
      let txClientName = row["txClient"] || "";
      let txFirstName = txClientName.split(" ")[0] || "";
      let txLastName = txClientName.substring(txFirstName.length).trim() || "";
      let txAnimalName = row["animal_txAnimal"] || "";
      let txPsName = row["txPs"] || "";
      let dtNextVisit = row["dtNext"] ? FxStr.substringBefore(row["dtNext"], " ") : "";

      txContent = txContent.replace(/\[name\]/g, txClientName);
      txContent = txContent.replace(/\[first_name\]/g, txFirstName);
      txContent = txContent.replace(/\[last_name\]/g, txLastName);
      txContent = txContent.replace(/\[contact\]/g, txClientName);
      txContent = txContent.replace(/\[animal\]/g, txAnimalName);
      txContent = txContent.replace(/\[ps\]/g, txPsName);
      txContent = txContent.replace(/\[alias\]/g, txPsName);
      txContent = txContent.replace(/\[next\]/g, dtNextVisit);
    }

    Promise.all([getWhatsappNumber(row["txMobile"])]).then((result) => {
      let txMobile = result[0];
      let url = `https://web.whatsapp.com/send?phone=${txMobile}&text=${encodeURIComponent(txContent)}`;
      FxLog.infox('MxMarketingList.doSendWhatsapp', '...url:', url);
      FxBrowser.windowOpen(url);
    });
  }

  const getTableColumns = () => {
    let cols = [];
    try {
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inClient", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: "txClient", Header: trans('field.client'), accessor: "txClient", width: '30%' });
        cols.push({ id: "txEmail", Header: trans('field.email'), accessor: "txEmail", width: '15%' });
        cols.push({ id: "txMobile", Header: trans('field.mobile'), accessor: "txMobile", width: '15%' });
        cols.push({ id: "txAddress", Header: trans('field.address'), accessor: "txAddress", width: '15%' });
        cols.push({ id: "txCity", Header: trans('field.city'), accessor: "txCity", width: '15%' });
        if ((isApp('vett') || isApp('spaw')) && storeMarketing.boGroupByClient==='0') {
          cols.push({ id: "inAnimal", Header: '_inAnimal', accessor: row => row["animal_inAnimal"], show: false });
          cols.push({ id: "txAnimal", Header: trans('field.patient'), accessor: "animal_txAnimal", width: '15%' });
        }
        if (storeMarketing.arPssFq) {
          cols.push({ id: "txPs", Header: trans('field.ps'), accessor: "txPs", width: '20%' });
        }
        cols.push({ id: id++, Header: trans('field.balance'), accessor: row => FxTable.cellTo2r00(row["theBalance"]), width: '10%', align: 'right' });

      } else { // PANTALLA PEQUEÑA
        cols.push({ id: "txClient", Header: trans('field.client'), accessor: "txClient", width: '70%' });
        if ((isApp('vett') || isApp('spaw')) && storeMarketing.boGroupByClient==='0') {
          cols.push({ id: "inAnimal", Header: '_inAnimal', accessor: "animal_inAnimal", show: false });
          cols.push({ id: "txAnimal", Header: trans('field.patient'), accessor: "animal_txAnimal", width: '30%' });
        } else {
          cols.push({ id: "txMobile", Header: trans('field.mobile'), accessor: "txMobile", width: '30%' });
        }

      }

      /* Esto sólo sirve para debug, cambiando a show: true */
      /*
      if ((isApp('opti') || isApp('vett') || isApp('spaw'))) {
        cols.push({ id: "inPs", Header: '_inPs', accessor: "inPs", show: false });
        cols.push({ id: "txPs", Header: '_txPs', accessor: "txPs", show: false });
        cols.push({ id: "dtNext", Header: '_dtNext', accessor: "dtNext", show: false });
      }
      */

      cols.push({ id: "B", Header: "cp_access", accessor: row => Boolean(row["inUser"]), show: false });
      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["dtTo"]), show: false });
      cols.push({ id: "R", Header: "balance", accessor: row => Boolean((row["theBalance"]) < 0 ? true : false), show: false });

      cols.push({
        id: "BTN_EXC", icon: <BiLockAlt />, icon_alt: <BiLockOpenAlt />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockExclude(!lockExclude),
        accessor: row => { return <CxIconButton type="cancel" classType="ibs_iconbutton_table_body" disabled={lockExclude} data={row} onClick={doExcludeClient} tooltip={trans("field.exclude_from_x", 'field.list')} /> },
        align: 'center', width: '33px'
      });

      if (storeMarketing.marketingType==='W') {
        cols.push({
          id: "BTN_SND", icon: <BiLockAlt />, icon_alt: <BiLockOpenAlt />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockSend(!lockSend),
          accessor: row => { return <CxIconButtonNew icon={<BsFillSendFill fontSize={19} />} classType="ibs_iconbutton_table_body" data={row} onClick={doSendWhatsapp} disabled={lockSend} tooltip={trans('field.send')} /> 
          },
          align: 'center', width: '33px'
        });
      }
  
    } catch (error) {
      FxLog.errorx('MxMarketingList.getTableColumns', error)
    }
    return cols;
  }

  const doExportCsv = () => {
    let record = {};
    let params = getAddParams().split("&");
    params.forEach(function (item, index) {
      record[item.split("=")[0]] = item.split("=")[1];
    });
    Promise.all([FxFetch.doJsonX(`marketing/export`, record)]).then((result) => {
      if (result[0]) {
        // cargar controles
        FxLog.infox('MxMarketingList.doExportCsv', '...:', result[0]);
        let _rawData = result[0];

        const _columnsToKeep = [
          { key: "txClient", dataKey: trans('field.client'), title: "Client" },
          { key: "txEmail", dataKey: trans('field.email'), title: "Email" },
          { key: "txMobile", dataKey: trans('field.mobile'), title: "Mobile" },
          { key: "animal_txAnimal", dataKey: trans('field.animal'), title: "Animal Name" },
          { key: "animal_txTypeAnimalSpecies", dataKey: trans('field.species'), title: "Species" },
        ];

        const { _processedData } = FxTable.csvChangeColumns(_rawData, _columnsToKeep);
        FxTable.csvDownload(_processedData, 'marketing');
      }
    });
  }

  const getAddParams = () => {
    return "marketingType=" + storeMarketing.marketingType + ""
      + "&inClient=" + storeMarketing.inClient + ""
      + "&dtRegisteredFrom=" + storeMarketing.dtRegisteredFrom + ""
      + "&dtRegisteredTo=" + storeMarketing.dtRegisteredTo + ""
      + "&dtBirthFrom=" + storeMarketing.dtBirthFrom + ""
      + "&dtBirthTo=" + storeMarketing.dtBirthTo + ""
      + "&inBranch=" + storeMarketing.inBranch + ""
      + "&txCity=" + storeMarketing.txCity + ""
      + "&txState=" + storeMarketing.txState + ""
      + "&txPostalCode=" + storeMarketing.txPostalCode + ""
      + "&txCountry=" + storeMarketing.txCountry + ""
      + "&nuMailing=" + storeMarketing.nuMailing + ""
      + "&txLang=" + storeMarketing.txLang + ""
      + "&boDebtor=" + storeMarketing.boDebtor + ""
      + "&arDocsSigned=" + storeMarketing.arDocsSigned + ""
      + "&dtPssFqFrom=" + storeMarketing.dtPssFqFrom + ""
      + "&dtPssFqTo=" + storeMarketing.dtPssFqTo + ""
      + "&arPssFq=" + storeMarketing.arPssFq + ""
      + "&boGroupByClient=" + storeMarketing.boGroupByClient + ""
      + "&boVaccLast=" + storeMarketing.boVaccLast + ""
      + "&dtAnimalBirthFrom=" + storeMarketing.dtAnimalBirthFrom + ""
      + "&dtAnimalBirthTo=" + storeMarketing.dtAnimalBirthTo + ""
      + "&txTypeAnimalSpecies=" + storeMarketing.txTypeAnimalSpecies + ""
      + "&txTypeAnimalBreed=" + storeMarketing.txTypeAnimalBreed + ""
      + "&arExcludedId=" + storeMarketing.arExcludedId + ""
      + "&dtLastInvoiceTo=" + storeMarketing.dtLastInvoiceTo + "";
  }

  return (
    <div>

      <GxList
        moduleName={`${trans('field.marketing')}: ${trans('msg.clients_with_x', 
          FxStr.choose(storeMarketing.marketingType, 'E|S|W', trans('field.email'), trans('field.mobile'), trans('field.mobile'))
        )}`}
        toolbarBackground={
          FxStr.choose(storeMarketing.marketingType, 'E|S|W', 'var(--ibs_color_red_light)', 'var(--ibs_color_yellow_light)', 'var(--ibs_color_blue_light)')
        }
        xref={r_list}
        fullscreen
        hasSearchBox={false}
        hasButtonAdd={false}
        url="marketing"
        addParams={getAddParams()}
        refColors={['table_cell_color_red|' + trans('field.debtor')]}
        columns={getTableColumns()}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<SiMicrosoftexcel fontSize="22px" style={{marginTop:'1px'}} />} classType="ibs_iconbutton_toolbar" 
              onClick={() => doExportCsv()} 
              tooltip={trans('field.export_to_x', 'excel')} 
            /> 
            {(storeMarketing.marketingType==='E' || storeMarketing.marketingType==='S') && 
              <CxIconButtonNew icon={<HiChevronDoubleRight fontSize={23} />} classType="ibs_iconbutton_toolbar" onClick={goNext} tooltip={trans('field.next')} />}
          </div>
        }
      >
      </GxList>

      <CxDlgAlert xref={r_dlg_alert} />
      <GxPrint xref={r_print} />

      <CxSnackbar xref={r_snack_success} severity="success" value={trans('msg.operation_successful')} />
      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxMarketingList;
